//用于aside和main组件的通信
import Vue from 'vue'
const eventAsideMain = new Vue()
export default eventAsideMain